import { ApolloClient, NormalizedCacheObject, useMutation } from '@apollo/client';
import { SavePaymentHistoryData, SavePaymentHistoryVars } from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../gql';
import PaymentEntry from 'dashboard/models/PaymentEntry';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

function usePaymentHistory() {
  if (!dashboardApolloClient) {
    dashboardApolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

 const [_savePaymentHistory, { loading, error, data }]
 = useMutation<SavePaymentHistoryData, SavePaymentHistoryVars>(
    GraphQL.Mutation.SAVE_PAYMENT_HISTORY,
    {
      client: dashboardApolloClient
    }
  );

  function savePaymentHistory(groupkey: number, input: PaymentEntry) {
    _savePaymentHistory({
      variables: {
        groupkey,
        input
      }
    })
  }

  return {
    savePaymentHistory,
    saving: loading,
    saveError: !!error,
    paymentHistory: data?.savePaymentHistory
  };
}

export default usePaymentHistory;
